export default __webpack_public_path__ + "static/media/IMG_1199.e76becd3.JPG";